import { useTranslation } from 'react-i18next';

import { images } from '../../constants';
import { contactInfo } from '../../data';
import './footer.scss';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <div className="Footer">

      <div className='Footer__left'>
      <div className="Footer__logo">
        <img src={images.logo} alt="NAIRDC Logo" />
        </div>
        <hr/>
      <div className="Footer__socials">

        <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/NAIRDCBH">
          <img src={images.linkedInIcon} alt="LinkedIn" />
        </a>

        <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/NAIRDC_BH/">
          <img src={images.instagramIcon} alt="Instagram" />
        </a>

        <a target="_blank" rel="noopener noreferrer" href="https://www.x.com/nairdc_bh/">
          <img src={images.xIcon} alt="X" />
        </a>

      </div>
      </div>

      <div className="Footer__contact">
        <h2>{t('footer.contactDetails')}</h2>
      <hr />
        <div className="Footer__contact-sections">
          <img src={images.location} alt="" />
          <p>{contactInfo.address}</p>
        </div>
        <div className="Footer__contact-sections">
          <img src={images.mail} alt="" />
          <p>{contactInfo.email}</p>
      </div>
        <div className="Footer__contact-sections">
          <img src={images.phone} alt="" />
          <p>{contactInfo.phone}</p>
        </div>

      </div>

      </div>
  )
}

export default Footer;